document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-kk-random-ebook]').forEach(function (group, groupIndex) {
    var candidates = Array.from(group.querySelectorAll('[data-kk-random-ebook-candidate]'));
    if (candidates.length < 2) return;

    var storageKey = 'kk-random-ebook-' + groupIndex;
    var previousIndex = -1;
    try {
      var storedIndex = window.sessionStorage.getItem(storageKey);
      if (storedIndex !== null) previousIndex = Number(storedIndex);
    } catch (error) { previousIndex = -1; }

    var selectedIndex;
    do {
      selectedIndex = Math.floor(Math.random() * candidates.length);
    } while (selectedIndex === previousIndex);

    candidates.forEach(function (candidate, index) {
      candidate.hidden = index !== selectedIndex;
    });
    try { window.sessionStorage.setItem(storageKey, String(selectedIndex)); } catch (error) { /* Storage can be disabled. */ }
  });

  var items = document.querySelectorAll('.kk-reveal');
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (item) { item.classList.add('is-visible'); });
  } else {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach(function (item) { observer.observe(item); });
  }

  document.querySelectorAll('[data-kk-testimonials]').forEach(function (carousel) {
    var viewport = carousel.querySelector('[data-kk-testimonials-viewport]');
    var slides = carousel.querySelectorAll('[data-kk-testimonials-slide]');
    var autoPlayTimer;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!viewport || slides.length < 2) return;

    function cardStep() {
      var gap = parseFloat(window.getComputedStyle(viewport.firstElementChild).gap) || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function visibleSlides() {
      var gap = parseFloat(window.getComputedStyle(viewport.firstElementChild).gap) || 0;
      return Math.max(1, Math.round((viewport.clientWidth + gap) / cardStep()));
    }

    function scroll(direction) {
      viewport.scrollBy({
        left: direction * cardStep() * visibleSlides(),
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    function canScroll() {
      return viewport.scrollWidth > viewport.clientWidth + 2;
    }

    function stopAutoPlay() {
      window.clearInterval(autoPlayTimer);
      autoPlayTimer = undefined;
    }

    function advance() {
      if (!canScroll()) return;

      var atEnd = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 2;
      if (atEnd) {
        viewport.scrollTo({ left: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      } else {
        scroll(1);
      }
    }

    function startAutoPlay() {
      stopAutoPlay();
      if (reduceMotion.matches || document.hidden || !canScroll()) return;
      autoPlayTimer = window.setInterval(advance, 6000);
    }

    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); scroll(-1); startAutoPlay(); }
      if (event.key === 'ArrowRight') { event.preventDefault(); scroll(1); startAutoPlay(); }
    });

    viewport.addEventListener('pointerdown', stopAutoPlay);
    viewport.addEventListener('pointerup', startAutoPlay);
    viewport.addEventListener('pointercancel', startAutoPlay);
    carousel.addEventListener('mouseenter', stopAutoPlay);
    carousel.addEventListener('mouseleave', startAutoPlay);
    carousel.addEventListener('focusin', stopAutoPlay);
    carousel.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!carousel.contains(document.activeElement)) startAutoPlay();
      }, 0);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoPlay(); else startAutoPlay();
    });
    reduceMotion.addEventListener('change', startAutoPlay);
    window.addEventListener('resize', startAutoPlay);
    startAutoPlay();
  });

  document.querySelectorAll('[data-kk-gallery]').forEach(function (gallery) {
    var dialog = gallery.querySelector('[data-kk-gallery-dialog]');
    var dialogImage = gallery.querySelector('[data-kk-gallery-image]');
    var closeButton = gallery.querySelector('[data-kk-gallery-close]');
    var galleryHeading = gallery.querySelector('[data-kk-gallery-heading]');
    var isVisible = !('IntersectionObserver' in window);

    if (!dialog || !dialogImage || !closeButton) return;

    function updateMotion() {
      gallery.classList.toggle('is-paused', document.hidden || !isVisible || dialog.open);
    }

    function closeDialog() {
      if (dialog.open && typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    gallery.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-kk-gallery-open]');
      if (!trigger || !gallery.contains(trigger)) return;

      dialogImage.src = trigger.dataset.kkGallerySrc;
      dialogImage.alt = trigger.dataset.kkGalleryAlt;

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      updateMotion();
    });

    closeButton.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', function () {
      var galleryRect = gallery.getBoundingClientRect();
      isVisible = galleryRect.bottom > 0 && galleryRect.top < window.innerHeight;
      if (galleryHeading) galleryHeading.focus({ preventScroll: true });
      updateMotion();
      window.requestAnimationFrame(updateMotion);
    });

    if ('IntersectionObserver' in window) {
      var galleryObserver = new IntersectionObserver(function (entries) {
        isVisible = entries[0].isIntersecting;
        updateMotion();
      }, { threshold: 0.01 });
      galleryObserver.observe(gallery);
    }

    document.addEventListener('visibilitychange', updateMotion);
    updateMotion();
  });

});
